import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'searchable-dropdown',
  templateUrl: './searchable-dropdown.component.html'
})
export class SearchableDropdownComponent implements OnInit {

  @Input() dropdownData: any;
  @Output() selectedDropDowns: EventEmitter<any> = new EventEmitter();

  @Input() public selectedValues: [];
  constructor() { }

  compareFn(val1, val2) {
    return val1.toString() === val2.toString();
  }

  ngOnInit() {
    // console.log('multiselect : ', this.dropdownData);
    // this.dropdownData = {
    //     type : 'searchable-dropdown',
    //     title : 'City',
    //     values : ['Bangalore', 'Hyderabad', 'Mumbai', 'Ahmedabad'],
    //     default : '',
    //     key : 'city-dropdown'
    //   };
  }

  chosenOptions() {
    const emitSelections = {
      [this.dropdownData.key] : this.selectedValues
    };
    this.selectedDropDowns.emit(emitSelections);
  }

}
